<div class="col-auto m-1">
  <ng-select
    class="w-100"
    bindValue="id"
    bindLabel="fullName"
    [placeholder]="label"
    [multiple]="multiple"
    (change)="onChange()"
    [items]="users"
    [(ngModel)]="selectedUsers"
    dropdownPosition="bottom" />
</div>
